import React, { useState, useEffect } from "react";
import { Alert, IconButton, Snackbar } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { useDispatch, useSelector } from "react-redux";
import { setMessage } from "../../../store/commonSlice";

const AlertMessage = () => {
  const dispatch = useAppDispatch();
  const { message, variant } = useAppSelector(({ common }) => common);

  const erroranchor = { horizontal: "center", vertical: "top" };
  const successanchor = { horizontal: "center", vertical: "top" };
  const [open, setOpen] = useState(false);
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    if (message) {
      setOpen(true);
      const id = setTimeout(() => {
        setOpen(false);
        dispatch(setMessage("", ""));
      }, 5000);
      setTimerId(id);
    }
  }, [dispatch, message]);

  const handleClose = () => {
    setOpen(false);
    dispatch(setMessage("", ""));
    clearTimeout(timerId);
  };

  if (message && variant) {
    return (
      <Snackbar
        open={open}
        autoHideDuration={6000}
        anchorOrigin={variant === "error" ? erroranchor : successanchor}
        onClose={handleClose}
        sx={{
          minWidth: "40%",
          maxWidth: "60%",
        }}
      >
        <Alert
          severity={variant}
          sx={{ width: "100%" }}
          action={
            <IconButton
              color="inherit"
              size="small"
              onClick={handleClose}
              sx={{ p: 0.5 }}
            >
              <Close fontSize="small" />
            </IconButton>
          }
          variant="filled"
        >
          {message}
        </Alert>
      </Snackbar>
    );
  }
  return null;
};

export default AlertMessage;
